import { FETCH_INSTRUCTORS, FETCH_INSTRUCTORS_SUCCESS, FETCH_INSTRUCTORS_FAILURE, SAVE_INSTRUCTORS_SUCCESS,
  SAVE_INSTRUCTORS_FAILURE, DELETE_INSTRUCTORS_SUCCESS, DELETE_INSTRUCTORS_FAILURE, INSTRUCTORS_AJAX_CALL,
  INSTRUCTORS_CLEAR_AJAX_CALL } from '../actions/Instructors'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function instructors (state = initialState, action) {
  switch (action.type) {
    case FETCH_INSTRUCTORS:
      return {...state, loading: true, error: null, list: null}
    case FETCH_INSTRUCTORS_SUCCESS:
      return {...state, list: action.payload, loading: false, error: null}
    case FETCH_INSTRUCTORS_FAILURE:
      return {...state, error: action.payload, loading: false, list: null}
    case SAVE_INSTRUCTORS_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.id) === -1)
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_INSTRUCTORS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_INSTRUCTORS_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_INSTRUCTORS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case INSTRUCTORS_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case INSTRUCTORS_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/instructors.js